<div class="op-dialog">

  <div class="op-header">
    <h2 class="op-title">
      <mat-icon>edit</mat-icon>
      Editar Orden
    </h2>
    <button mat-icon-button class="close-button" mat-dialog-close aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="op-content">

    <app-cotizacion-fuente
        [wallet]="wallet" [isBroker]="true" [stkcfd]="secType"
        [idNectum]="data.orden.idNectum" [symbol]="orden.ticker" [conid]="orden.conid"
        [fecha]="hoy" [decimales]="decimales">
    </app-cotizacion-fuente>

    <div class="section-header mt-3">
      <mat-icon class="small-icon">receipt_long</mat-icon>
      <span>Orden</span>
      <span class="entrada-badge ms-auto" [class.alcista]="orden.side === 'BUY'" [class.bajista]="orden.side === 'SELL'">
        {{ orden.side }}
      </span>
    </div>

    <div class="fields-grid">
      <label class="field-label">Tipo Orden</label>
      <input type="text" class="dense-input" [(ngModel)]="orden.orderType" [disabled]="true">

      <label class="field-label">Precio orden</label>
      <input type="number" class="dense-input" [(ngModel)]="orden.price" [step]="paso">

      <label class="field-label">Compañía</label>
      <input type="text" class="dense-input" [(ngModel)]="orden.ticker" [disabled]="true">

      <label class="field-label">Cantidad</label>
      <input type="number" class="dense-input" [(ngModel)]="orden.quantity" [disabled]="true">

      <ng-container *ngIf="fecha">
        <label class="field-label">Fecha</label>
        <input type="text" class="dense-input" [(ngModel)]="fecha" [disabled]="true">
      </ng-container>
    </div>

  </div>

  <div class="op-actions">
    <button mat-stroked-button mat-dialog-close>Cancelar</button>
    <button mat-flat-button class="ccorbit fw-semibold" (click)="editarOrden()">Aceptar</button>
  </div>

</div>
